module.exports = __webpack_public_path__ + "img/ev_charger_grey_line.62cbb353.png";